export const getEmailIconOptions = (t: Function) => [
  { title: t('Do not change'), id: -1 },
  { title: t('Animated snapshot'), id: 135 },
  { title: t('Video snapshot'), id: 8 },
];

export const getCaptionOptions = (t: Function) => [
  { title: t('Do not change'), id: -1 },
  { title: t('Let me choose which videos to transcribe'), id: 0 },
  { title: t('Automatically transcribe every new video'), id: 1 },
];

export const getCaptionVisibilityOptions = (t: Function) => [
  { title: t('Do not change'), id: -1 },
  { title: t('Let me verify captions before showing on video'), id: 0 },
  { title: t('Automatically show captions on all videos'), id: 1 },
];

export const getEmailOptions = (t: Function) => [
  { title: t('Do not change'), id: -1 },
  { title: t('Enable'), id: 1 },
  { title: t('Disabled'), id: 0 },
];
